import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const SpeechSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SpeechInputBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  background-color: ${COLORS.white};
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  &:focus-within {
    border-color: ${COLORS.primaryDark};
    box-shadow: 0 0 0 1px ${COLORS.secondary};
  }
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 12px;
`

export const Counter = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.secondarySemiLight};
  font-variant-numeric: tabular-nums;
`

export const WarningRow = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: -2px;
  color: ${COLORS.warningColor};

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`

export const WarningText = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${COLORS.warningColor};
`

export const UpgradeLink = styled.button`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  margin-top: -2px;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const UpgradeText = styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 100%;
  text-decoration: underline;
  text-decoration-color: #2f67fe;
  background: linear-gradient(
    261.91deg,
    #2214e4 -3.09%,
    #d696ce 47.21%,
    #2f67fe 93.65%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`
